import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';

function Withdrawal() {
  const [tranx, setTranx] = useState([]);
  const [filteredTranx, setFilteredTranx] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTrn, setSelectedTrn] = useState(null);
  const [popup, setPopup] = useState({ message: "", type: "" });

  const [previewImage, setPreviewImage] = useState(null);

  useEffect(() => {
    fetchTranx();
  }, []);

  const fetchTranx = async () => {
    try {
      const res = await axios.get('https://api.bigfresh.in/fetch-tranx');
      setTranx(res.data.tranxData);
      setFilteredTranx(res.data.tranxData);
    } catch (err) {
      console.error(err);
    }
  };

  // Search filter
  useEffect(() => {
    const term = searchTerm.toLowerCase();
    setFilteredTranx(
      tranx.filter(t =>
        t.name?.toLowerCase().includes(term) ||
        t.id?.toString().includes(term)
      )
    );
  }, [searchTerm, tranx]);

  const handleVerify = async () => {
    try {
      const res = await axios.post(
        'https://api.bigfresh.in/tranx-verify',
        { id: selectedTrn }
      );

      setTranx(prev =>
        prev.map(t =>
          t.id === selectedTrn ? { ...t, is_verify: 'Verified..' } : t
        )
      );

      setPopup({ message: res.data.message || "Verified successfully", type: "success" });
    } catch {
      setPopup({ message: "Verification failed", type: "error" });
    }

    setSelectedTrn(null);
    setTimeout(() => setPopup({ message: "", type: "" }), 2000);
  };

  return (
    <div className="dashboard-container">
      {/* <SidebarNav />
      <PageHeader title="Transaction Wallet" /> */}

      <div className="main-dashboard">
         <h3 className="text-center  mb-4 text-success fw-bold">Withdrawal Section</h3>

        <input
          className="form-control w-50 mb-4"
          placeholder="Search by ID or Name"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />

        <table className="table table-bordered table-hover">
          <thead className="table-dark">
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Transaction ID</th>
              <th>Amount</th>
              <th>File</th>
              <th>Verification</th>
            </tr>
          </thead>

          <tbody>
            {filteredTranx.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center">No transactions found</td>
              </tr>
            ) : (
              filteredTranx.map(t => (
                <tr key={t.id}>
                  <td>{t.id}</td>
                  <td>{t.name}</td>
                  <td>{t.tranxid}</td>
                  <td>{t.amount}</td>

                  <td>
                    {t.file ? (
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => setPreviewImage(t.file)}
                      >
                        Preview
                      </button>
                    ) : (
                      <span className="text-danger">No Image</span>
                    )}
                  </td>

                  <td>
                    <button
                      className="btn btn-success btn-sm"
                      disabled={t.is_verify ===  'Verified'}
                      onClick={() => setSelectedTrn(t.id)}
                    >
                      {t.is_verify}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {/* Image Preview Modal */}
 {previewImage && (
  <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50" style={{ zIndex: 1050 }}>
    <div className="bg-white p-2 rounded shadow-lg position-relative text-center">
      {/* Close button at top-right */}
      <button
        className="btn btn-danger position-absolute top-0 end-0 m-2"
        onClick={() => setPreviewImage(null)}
      >
        &times;
      </button>

      <img
        src={`https://api.bigfresh.in/uploads/${previewImage}`}
        alt="preview"
        className="img-fluid rounded"
        style={{ maxWidth: '50%', maxHeight: '50vh' }}
      />
    </div>
  </div>
)}


      

        {selectedTrn && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
  >
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">Confirmation</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setSelectedTrn(null)}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to verify?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-success"
            onClick={handleVerify}
          >
            OK
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setSelectedTrn(null)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)}


      </div>
    </div>
  );
}

export default Withdrawal;
